import { Integration } from 'models/integrations'
import api from '../index'

export interface IIntegrationsAPI {
  data: {
    attributes: Integration
    id: string
    type: string
  }[]
}
export const providersList = () => {
  return api
    .get<IIntegrationsAPI>('integrations/providers_list')
    .then((res) => res.data)
    .then(({ data }) => data.map(({ attributes }) => attributes))
}

export default providersList